import Layout from "../components/Layout"
import Helmet from "react-helmet"
import { navigate, withPrefix } from "gatsby"
import React from "react"
import { Router } from "@reach/router"
import { css } from "styled-components"
import { Lines } from "../components/atoms/Spinners"

const Navigate = props => {
  // console.log(props)
  if (typeof window !== `undefined`) {
    props.slug
      ? navigate(`/${props.slug}`, { state: { addMode: true } })
      : navigate("/all")
  }
  return <Lines />
}

const TemplateAddPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Processing</title>
      </Helmet>
      <div
        css={css`
          display: flex;
          justify-content: center;
        `}
      >
        <Router basepath={withPrefix("/add")}>
          <Navigate path="/:slug/" />
          <Navigate default />
        </Router>
      </div>
    </Layout>
  )
}

export default TemplateAddPage
